import { useNavigate } from 'react-router-dom';
import useReviews from '../../Hooks/useReviews';
import SingleReview from '../SingleReview/SingleReview';
import { AiOutlineArrowRight } from 'react-icons/ai'
import "./Home.css";
const Home = () => {

    const [reviews, setReviews] = useReviews();

    const firstThree = reviews.slice(0, 3);
    const navigate = useNavigate();

    return (
        <div>

            <section className='banner-container'>
                <div className='banner-left'>
                    <h1>Ibanez Guitar</h1>
                    <p>The new models of the Ibanez Performance Series represent a strong focus on sound quality and performance at an excellent value. With over 50 years of experience to draw from, the new Performance Series models will raise the bar on what can be expected from an economical, entry-level instrument. </p>
                    <button className='btn'>Buy Now</button>
                </div>
                <div className='banner-right'>
                    <img src={require("../../Images/Guitar-2.png")} alt="" />
                </div>
            </section>
            <section className='review-container'>
                <h1 className='headline'>Customer Reviews</h1>
                <div className='reviews'>
                    {
                        firstThree.map(review => <SingleReview
                            key={review.id}
                            review={review}
                        ></SingleReview>)
                    }
                </div>
                <div className='see-all-btn'>
                    <button onClick={() => navigate('/reviews')} className='btn '>See All Reviews
                        <AiOutlineArrowRight></AiOutlineArrowRight>
                    </button>
                </div>

            </section>
        </div>
    );
};

export default Home;